export const PUBLISH_TYPE = {
  IMMEDIATELY: 'immediately',
  SCHEDULED: 'scheduled',
} as const;

export const PUBLISH_SETTING_OPTIONS = [
  { value: PUBLISH_TYPE.IMMEDIATELY, label: '今すぐ公開する' },
  { value: PUBLISH_TYPE.SCHEDULED, label: '予約投稿' },
] as const;

/** 添付ファイルの最大アップロード件数 */
export const MAX_ATTACHMENT_FILES = 10;
